export const toISODate = (date) => {
  const [day, month, year] = date.split('/');
  const ISODate = `${year}-${month}-${day}`;
  return ISODate;
};

export const formatDate = (date) => {
  const [year, month, day] = date.slice(0, 10).split('-');
  const formattedDate = `${day}/${month}/${year}`;
  return formattedDate;
};
